import {
  Box,
  Icon
} from "@chakra-ui/react";
import React from "react";
import {
  FaMicrophone,
  FaMicrophoneSlash
} from "react-icons/fa";
import styled, { css } from "styled-components";

import { AudioAnalyser } from "src/components/audio/AudioAnalyser";
import { Avatar } from "src/components/avatar";
import { Text } from "src/components/text";
import { theme } from "src/components/theme";

interface AudioBoxProps {
  audioDisabled?: boolean;
  analyser?: AnalyserNode;
  name: string;
  byCurrentUser?: boolean
  delayMs: number;
  hidden?: boolean;
  onMute?: () => void;
  muted?: boolean;
}

export const UserAudio: React.FC<AudioBoxProps> = props => {
  return (
    <AudioBox className={`${props.byCurrentUser && "byCurrentUser"} ${props.hidden && "hideBox"} `}>

      {/* {props.analyser && (
        <AudioAnalyser
          analyser={props.analyser}
          delayMs={props.delayMs}
          name={props.name} />
      )} */}

      <Box className="avatar-wrap">
        <Avatar
          hideName
          name={props.name}
        />

        <Text>
          {props.name}
        </Text>
      </Box>

      {props.onMute && (
        <MuteBox
          muted={props.muted || props.audioDisabled}
          disabled={props.audioDisabled}
          onClick={props.onMute}
        >

          {props.muted ? (
            <Icon
              color={theme.colors.error}
              as={FaMicrophoneSlash}
            />

          ) : (

            <Icon
              as={FaMicrophone}
            />
          )}
        </MuteBox>
      )}

    </AudioBox>
  );
};

const AudioBox = styled(Box)`
  ${({ theme }) => css`
    position: absolute;

    &.hideBox {
      display: none;
    }

    top: 1.5rem;
    left: 1.5rem;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    border: 2px solid ${theme.colors.main};
    padding: 20px;
    border-radius: 10px;
    width: 300px;

    .avatar-wrap {
      display: flex;
      align-items: center;

      > span {
        margin: 0 1rem
      }
    }


    canvas {
      position: absolute;
      margin: 0px auto;
      display: block;
      width: 300px;
      height: 100px;
      top: 50%;
      left: 0;
      transform: translateY(-50%);
      z-index: 0;
    }

    &.byCurrentUser {
      top: auto;
      left: auto;
      bottom: 1.5rem;
      right: 1.5rem;
      flex-direction: row-reverse;
      background: ${theme.colors.main};
      display: flex;
      .avatar-wrap {
        display: flex;
        flex-direction: row-reverse;
      }

      canvas {
        left: auto;
        right: 0;
      }
    }

  `}
`;

const MuteBox = styled(Box)<{ muted: boolean, disabled: boolean }>`
  display: flex;
  cursor: ${({ disabled }) => disabled ? "pointer" : "default"};
  opacity: ${({ disabled }) => disabled ? 0.6 : 1};
  justify-content: center;
  align-items: center;
  border-radius: 100%;
  background: ${({ muted }) => muted ? "white" : "#FFFFFF40"};
  padding: 1rem;
`;